/**
 * ReadinessGate — Route-level progressive disclosure
 *
 * Shows LockerRoom when onboarding is incomplete, otherwise renders children.
 * Used to wrap sport dashboard routes so new users see the gamified onboarding
 * experience instead of an empty dashboard.
 */

import React, { Suspense, lazy } from 'react';
import useGamification from '../../hooks/useGamification';

const LockerRoom = lazy(() => import('./LockerRoom'));

export default function ReadinessGate({ children }) {
  const { onboardingComplete, loading } = useGamification();

  if (loading) return null;

  if (!onboardingComplete) {
    return (
      <Suspense fallback={null}>
        <LockerRoom />
      </Suspense>
    );
  }

  return children;
}
